import React from 'react';
import {alpha, CircularProgress, IconButton, IconButtonProps, Tooltip, useTheme} from '@mui/material';
import {Box} from '@mui/material';

export interface AppIconButtonProps extends IconButtonProps {
    variant?: 'outlined' | 'none';
    isLoading?: boolean;
    elevation?: boolean;
    tooltip?: string;
}

export const AppIconButton = React.forwardRef<HTMLButtonElement, AppIconButtonProps>(
    ({children, variant = 'none', isLoading, elevation, tooltip, ...rest}, ref) => {
        const theme = useTheme();

        const button = (
            <IconButton
                ref={ref}
                size="medium"
                sx={{
                    height: '30px',
                    minWidth: '10px',
                    border: variant === 'outlined' ? '1px solid' : 'none',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    ...(elevation && {
                        backgroundColor: '#fff',
                        boxShadow: theme.shadows[3],
                        '&:hover': {
                            backgroundColor: alpha(theme.palette.primary.main, 0.1),
                            transform: 'scale(1.05)',
                        },
                    }),
                }}
                {...rest}
            >
                {isLoading ? (
                    <Box>
                        <CircularProgress style={{marginTop: '5px'}} size={20} />
                    </Box>
                ) : (
                    children
                )}
            </IconButton>
        );

        return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
    },
);

export default AppIconButton;
